// Paneles de Reportes — pantalla propia, con su entrada en el menú.
//
// Era la tercera pestaña de Reportes de Equipo. Se sacó porque ahí no se
// encontraba: quien busca "mandar el reporte de ventas por correo" no entra a
// una pantalla que se llama Reportes de Equipo. La pantalla no tiene lógica
// propia — es el encabezado y TeamDashboardsTab, que es donde está todo.

import { LayoutDashboard } from 'lucide-react';
import TeamDashboardsTab from './TeamDashboardsTab.jsx';
import { useTeamMetrics } from './teamMetricsCatalog.jsx';

export default function ReportDashboardsView({ lang = 'en', currentUser, policies = [], clients = [], onClientClick }) {
  const es = lang === 'es';
  const t = (a, b) => (es ? a : b);

  const METRICS = useTeamMetrics(lang);
  // Mismo criterio que Reportes de Equipo: un asiento mira, no arma.
  const canManage = currentUser?.role !== 'assistant';

  return (
    // A todo lo ancho (VISTAS_A_TODO_LO_ANCHO en deskte-full.jsx): un panel con
    // cuatro indicadores en fila no cabe en 1000 px.
    <div style={{ padding: '1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '.35rem' }}>
        <LayoutDashboard size={22} color="#00d4ff" />
        <h2 style={{ margin: 0, fontSize: '1.4rem', color: 'var(--c-white,#eef6ff)' }}>
          {t('Paneles de Reportes', 'Report Dashboards')}
        </h2>
      </div>
      <div style={{ fontSize: '.85rem', color: 'var(--c-text2,#7aa3c0)', marginBottom: '1.25rem' }}>
        {t('Arma tu tablero con gráficas interactivas de pólizas, prima y comisión — con filtros de fechas, personas, estados y más — junto a los reportes de clientes, ventas, métricas y equipo. Se actualiza solo y se puede programar por correo.',
           'Build your board with interactive charts of policies, premium and commission — filtered by dates, people, states and more — next to the client, sales, metrics and team reports. It refreshes by itself and can be scheduled by email.')}
      </div>

      <TeamDashboardsTab lang={lang} METRICS={METRICS} canManage={canManage} policies={policies} clients={clients} onClientClick={onClientClick} />
    </div>
  );
}
